module.exports = __webpack_public_path__ + "fonts/la-brands-400.a38ca9f0.eot";